export const GENERIC = 'generic'
export const NORMALS_YEARS = 'normalsYears'
export const NORMALS_MONTHS = 'normalsMonths'
export const MONTHS_STACK = 'monthsStack'
export const EFFICIENT_RAIN = 'efficientRain'
export const NORMAL_COMPARISON = 'comparisonNormal'

export const STATS_TAB = 'STATS'
export const THRESHOLDS_TAB = 'THRESHOLDS'
export const MODELS_TAB = 'MODELS'
export const CHARTOPTIONS_TAB = 'CHARTOPTIONS'
export const EVENTS_TAB = 'EVENTS'
export const LINKEDSTATIONS_TAB = 'LINKEDSTATIONS'

export const HIDDEN_THRESHOLDS_PLUVIOMETRIC_FOLLOW = 'HIDDEN_THRESHOLDS_PLUVIOMETRIC_FOLLOW'
export const PLUVIO_FOLLOW_MODEL_CHECK = 'PLUVIO_FOLLOW_MODEL_CHECK'
export const PLUVIO_FOLLOW_CHART_OPTIONS = 'PLUVIO_FOLLOW_CHART_OPTIONS'
export const PLUVIO_FOLLOW_CHART_TYPE = 'PLUVIO_FOLLOW_CHART_TYPE'
